var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "db relative w-100 h-100 nav-wrapper" }, [
    _c(
      "div",
      { staticClass: "flex relative w-100 h-100 flex-column justify-center" },
      [
        _c(
          "nav",
          { staticClass: "db relative mv4 ph4 tl" },
          [
            _c(
              "div",
              { staticClass: "relative mv2 pv1" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "relative no-underline is-tablet-bold is-cream nav-primary",
                    attrs: { to: "/", title: "Outside Lands Home" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.closeNavBusMethod()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "relative z-0 f2 text" }, [
                      _vm._v("\n            Home\n          "),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.navigation.navigation_items, function (item, index) {
              return _c(
                "div",
                {
                  key: "mobile-nav-item" + index,
                  staticClass: "relative mv2 pv1",
                  class: { dn: !item.is_published },
                },
                [
                  item.title === "Merch"
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "relative no-underline is-tablet-bold is-cream nav-primary",
                          attrs: {
                            href: item.link,
                            target: "_blank",
                            title: item.title,
                            id: item.id,
                          },
                        },
                        [
                          item.is_primary
                            ? _c(
                                "span",
                                { staticClass: "relative z-0 f2 text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.title) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                { staticClass: "relative z-0 f3 text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.title) +
                                      "\n          "
                                  ),
                                ]
                              ),
                        ]
                      )
                    : _c(
                        "router-link",
                        {
                          staticClass:
                            "relative no-underline is-tablet-bold is-cream nav-primary",
                          attrs: {
                            to: item.link,
                            title: item.title,
                            id: item.id,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.closeNavBusMethod()
                            },
                          },
                        },
                        [
                          item.is_primary
                            ? _c(
                                "span",
                                { staticClass: "relative z-0 f2 text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.title) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                { staticClass: "relative z-0 f3 text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.title) +
                                      "\n          "
                                  ),
                                ]
                              ),
                        ]
                      ),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "db absolute bottom-0 left-0 w-100 mw20rem ml4 mb2" },
      [
        _c(
          "div",
          {
            staticClass: "relative flex flex-row items-center justify-between",
          },
          _vm._l(_vm.footer_content.socials, function (social) {
            return _c(
              "a",
              {
                key: social.title,
                staticClass: "dib relative pointer social-icon is-teal-icon",
                attrs: {
                  href: social.link,
                  target: "_blank",
                  title: social.title,
                },
              },
              [
                _c("span", {
                  staticClass: "icon",
                  domProps: { innerHTML: _vm._s(social.icon_svg) },
                }),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }